import { render } from "./UserBioSettings.vue?vue&type=template&id=2fe4dee9"
import script from "./UserBioSettings.vue?vue&type=script&lang=js"
export * from "./UserBioSettings.vue?vue&type=script&lang=js"

import "./UserBioSettings.vue?vue&type=style&index=0&id=2fe4dee9&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__